import React from 'react';
import { IncidentAnalysis } from '../../types/incident';

interface ActionItemsProps {
    analysis: IncidentAnalysis;
}

const ActionItems: React.FC<ActionItemsProps> = ({ analysis }) => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Next Steps */}
            {analysis.next_steps && analysis.next_steps.length > 0 && (
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    <h4 className="font-medium text-gray-900 mb-4">Next Steps</h4>
                    <div className="space-y-3">
                        {analysis.next_steps.map((step: string, index: number) => (
                            <div key={index} className="flex items-start">
                                <span className="flex-shrink-0 w-6 h-6 bg-blue-600 text-white text-xs rounded-full flex items-center justify-center mr-3 mt-0.5">
                                    {index + 1}
                                </span>
                                <p className="text-sm text-gray-900">{step}</p>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Required Resources */}
            {analysis.resources_needed && analysis.resources_needed.length > 0 && (
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    <h4 className="font-medium text-gray-900 mb-4">Required Resources</h4>
                    <div className="space-y-2">
                        {analysis.resources_needed.map((resource: string, index: number) => (
                            <div key={index} className="flex items-center">
                                <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                                <p className="text-sm text-gray-900">{resource}</p>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ActionItems;
